'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.setSpvStorage = setSpvStorage;
exports.getSpvFromStorage = getSpvFromStorage;
exports.cleanSpvStorage = cleanSpvStorage;
exports.track = track;
exports.showLoading = showLoading;
exports.hideLoading = hideLoading;
exports.emit = emit;
exports.axios = axios;
exports.setClient = setClient;
exports.getClient = getClient;
exports.clone = clone;
exports.create = create;
exports.getInstance = getInstance;
exports.deleteInstance = deleteInstance;
exports.cleanPacks = cleanPacks;
exports.iposCleanPacks = iposCleanPacks;
exports.toFirst = toFirst;
exports.levelText = levelText;

var _axiosM = require('@beastshop/axios-m');

var _axiosM2 = _interopRequireDefault(_axiosM);

var _events = require('events');

var _browser = require('@beastshop/browser');

var _browser2 = _interopRequireDefault(_browser);

var _bridge = require('@beastshop/bridge');

var _bridge2 = _interopRequireDefault(_bridge);

var _tracker = require('@beastshop/tracker');

var _tracker2 = _interopRequireDefault(_tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = _browser2.default.app();

var guid = 1;
var instanceMap = {};
var CLIENT = void 0;

var exportData = {
  axios: axios,
  setClient: setClient,
  clone: clone,
  create: create,
  getClient: getClient,
  instanceMap: instanceMap,
  getInstance: getInstance,
  cleanPacks: cleanPacks,
  iposCleanPacks: iposCleanPacks,
  emit: emit,
  showLoading: showLoading,
  hideLoading: hideLoading,
  eventPasser: new _events.EventEmitter(),
  track: track,
  deleteInstance: deleteInstance,
  cleanSpvStorage: cleanSpvStorage,
  getSpvFromStorage: getSpvFromStorage,
  setSpvStorage: setSpvStorage,
  toFirst: toFirst,
  levelText: levelText

  // { label, addiblePack, time }
};function setSpvStorage(data, type) {
  var now = +new Date();
  try {
    var cartSpvs = window.localStorage.cartSpvs;
    if (cartSpvs) {
      cartSpvs = JSON.parse(cartSpvs);
      cartSpvs.time = now;
      cartSpvs[type][data.productId] = data.spv;
      window.localStorage.cartSpvs = (0, _stringify2.default)(cartSpvs);
    } else {
      var spvs = {};
      spvs.time = now;
      spvs[type] = {};
      spvs[type][data.productId] = data.spv;
      window.localStorage.cartSpvs = (0, _stringify2.default)(spvs);
    }
  } catch (e) {}
}

function getSpvFromStorage(productId, type) {
  try {
    var cartSpvs = window.localStorage.cartSpvs;
    if (cartSpvs) {
      cartSpvs = JSON.parse(cartSpvs);
      return cartSpvs[type][productId];
    } else {
      return null;
    }
  } catch (e) {}
}

function cleanSpvStorage() {
  try {
    var cartSpvs = window.localStorage.cartSpvs;
    if (!cartSpvs) {
      return;
    }
    var spvs = JSON.parse(cartSpvs);
    var expireTime = 8 * 60 * 60 * 1000; // 8 hours
    var now = +new Date();
    var time = spvs.time;
    if (now - time > expireTime) {
      delete window.localStorage.cartSpvs;
    }
  } catch (e) {}
}

function track(name) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var jump = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return;
  if (app) {
    _bridge2.default.track({
      name: name,
      attrs: attrs
    });
    return _promise2.default.resolve();
  } else {
    var _resolve = void 0;
    var promise = new _promise2.default(function (resolve) {
      _resolve = resolve;
    });
    (0, _tracker2.default)({
      name: name,
      attrs: attrs,
      wait: !jump
    });
    if (jump === true) {
      //give 200ms to send XHR, before jump
      setTimeout(_resolve, 200);
    } else {
      _resolve();
    }
    return promise;
  }
}

function showLoading() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  emit.apply(undefined, ['show-loading'].concat(args));
}

function hideLoading() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  emit.apply(undefined, ['hide-loading'].concat(args));
}

// event will be passed on to Cart instance finally
function emit() {
  var _exportData$eventPass;

  (_exportData$eventPass = exportData.eventPasser).emit.apply(_exportData$eventPass, arguments);
}

function axios(options) {
  // console.log(options)
  // options.headers = {
  //   'TBS-Client': 4,
  //   'TBS-Channel': 'CHN1004',
  //   'TBS-Staff-Auth': '1-ffab86d2-e486-4d1c-afae-eed43f5441f3'
  // }
  return (0, _axiosM2.default)(options);
}

function setClient(client) {
  CLIENT = client;
}

function getClient() {
  return CLIENT;
}

function clone(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
}

function create(c, data, type) {
  var g_uid = guid++;
  data.g_uid = g_uid;
  var instance = type ? new c(data, type) : new c(data);
  instanceMap[g_uid] = instance;
  return instance;
}

function getInstance(guid) {
  return instanceMap[guid];
}

function deleteInstance(guid) {
  delete instanceMap[guid];
}

function cleanPacks() {
  var packs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return packs.map(function (pack) {
    if (pack.customized) {
      return pack.id ? {
        id: pack.id,
        customizes: pack.customizes
      } : {
        spvId: pack.spv.id,
        count: pack.count,
        source: pack.source,
        customizes: pack.customizes
      };
    } else {
      return pack.id ? { id: pack.id } : {
        spvId: pack.spv.id,
        count: pack.count,
        source: pack.source,
        campaignSectionId: pack.campaignSectionId || ''
      };
    }
  });
}

function iposCleanPacks() {
  var packs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return packs.map(function (pack) {
    var result = iposClean(pack);
    // if (pack.source === 'RAW' && pack.giftPacks) {
    //   result.giftPacks = pack.giftPacks.filter((g) => {
    //     return g.owned
    //   }).map(iposClean)
    // }
    if (pack.source === 'RAW' && pack.giftCampaigns) {
      // result.giftCampaigns = pack.giftCampaigns.map(iposClean)
      // console.log('fasdasdasdasd', pack.giftCampaigns)
      var giftCampaigns = [];
      pack.giftCampaigns.forEach(function (g) {
        g.sections.forEach(function (s) {
          s.satisfied && s.owned && s.products.forEach(function (p) {
            p.giftPacks.forEach(function (gp) {
              if (gp.storeCount || gp.warehouseCount) {
                giftCampaigns.push(iposClean(gp));
              }
            });
          });
        });
      });
      result.giftCampaigns = giftCampaigns;
    }
    return result;
  });
}

function iposClean(pack) {
  var result = void 0;
  if (pack.customized) {
    result = pack.id ? {
      id: pack.id,
      customizes: pack.customizes
    } : {
      spvId: pack.spv.id,
      count: pack.count,
      source: pack.source,
      customizes: pack.customizes
    };
  } else {
    result = pack.id ? {
      id: pack.id
    } : {
      spvId: pack.spv.id,
      count: pack.count,
      source: pack.source
    };
  }
  result.storeCount = pack.storeCount, result.warehouseCount = pack.warehouseCount;
  result.left = pack.spv && pack.spv.left;
  if (pack.sectionId) {
    result.campaignSectionId = pack.sectionId;
  }
  return result;
}

function toFirst(array, target) {
  array.splice(array.indexOf(target), 1);
  array.unshift(target);
}

function levelText(levelIds) {
  var map = {
    '-1': '注册',
    0: '松鼠',
    1: '小猫',
    2: '老虎',
    3: '大象'
  };
  levelIds = levelIds || [];
  if (!levelIds.length || levelIds.length === 5) {
    return;
  }
  return levelIds.map(function (el) {
    return map[el];
  }).join('') + '专享';
}

exports.default = exportData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/util.js
// module id = 239
// module chunks = 0